<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменение доставки
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>
      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <before-after-log-item>
        <template v-slot:before>
          <div class="delivery-log-item">
            <div class="delivery-log-item_name">
              {{ oldDeliveryTypeName }}
            </div>
            <div v-if="oldAddress" class="delivery-log-item__address">
              {{ oldAddress }}
            </div>
          </div>
        </template>
        <template v-slot:after>
          <div class="delivery-log-item">
            <div class="delivery-log-item_name">
              {{ deliveryTypeName }}
            </div>
            <div v-if="address" class="delivery-log-item__address">
              {{ address }}
            </div>
          </div>
        </template>
      </before-after-log-item>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'
  import DeliveryType from '@/models/enums/DeliveryType'

  export default {
    name: 'HistoryItemTypeDelivery',
    components: { BeforeAfterLogItem, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      deliveryTypeName () {
        return DeliveryType.getName(this.item.deliveryType)
      },
      oldDeliveryTypeName () {
        return DeliveryType.getName(this.item.oldDeliveryType)
      },
      address () {
        if (!this.item.clientAddressId) {
          return null
        }
        return this.item.clientAddress.fullAddress
      },
      oldAddress () {
        if (!this.item.oldClientAddressId) {
          return null
        }
        return this.item.oldClientAddress.fullAddress
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";

.delivery-log-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  &__address {
    color: #6d6d6d;
    font-size: 0.85em;
  }
}
</style>
